export class Role {
  public static readonly SUPERADMIN = 1;
  public static readonly PNS = 2;
  public static readonly ADMIN_CUTI = 3;
  public static readonly ADMIN_KEPEGAWAIAN = 4;
  public static readonly NON_PNS = 5;
}
